var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5175 10.4999H20.5332C21.1223 10.4999 21.5999 10.9775 21.5999 11.5666V17.7979V18.0999C21.5999 19.2045 20.7045 20.0999 19.5999 20.0999H4.7999M2.3999 4.96657V17.9999C2.3999 19.1597 3.3401 20.0999 4.4999 20.0999V20.0999C5.6597 20.0999 6.5999 19.1597 6.5999 17.9999V11.5666C6.5999 10.9775 7.07746 10.4999 7.66657 10.4999H19.4666V7.97833C19.4666 7.38923 18.989 6.91167 18.3999 6.91167H11.3725L9.7425 4.38788C9.54603 4.08365 9.20861 3.8999 8.84646 3.8999H3.46657C2.87747 3.8999 2.3999 4.37747 2.3999 4.96657Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDrive);
export default __webpack_public_path__ + "static/media/folder-drive.f91ec974082e9a61d153a1f69bcef136.svg";
export { ForwardRef as ReactComponent };